import { initializeApp, getApps, getApp } from 'firebase/app';
import { getFirestore } from 'firebase/firestore';
import { getStorage } from 'firebase/storage';
import { getAuth } from 'firebase/auth'

const firebaseConfig = {
  apiKey: "AIzaSyDIrxgShoiPurMQXQ25i0yfwNR6ro2rcKQ",
  authDomain: "enjoyabledesign-a7576.firebaseapp.com",
  projectId: "enjoyabledesign-a7576",
  storageBucket: "enjoyabledesign-a7576.appspot.com",
  messagingSenderId: "1002217513839",
  appId: "1:1002217513839:web:9c9890b84ba944c9c0fe9a",
  measurementId: "G-LDG7D2L66K"
};

const app = !getApps().length ? initializeApp(firebaseConfig) : getApp();

// Initialize Firestore and Storage
const db = getFirestore(app);
const storage = getStorage(app);

export { db, storage };
export const auth = getAuth(app);
